import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/react'
import CIcon from '@coreui/icons-react'

import { AppSidebarNav } from './AppSidebarNav'
import logo from 'src/assets/images/logo.svg' // Import the SVG image

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

// sidebar nav config
import navigation from '../_nav'
import routes from 'src/routes'
import PropTypes from 'prop-types'

const AppSidebar = ({ filteredNavs }) => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const isRouteisAccessible = (route) => {
    if (routes.find((value) => value.path === route && value.roles.includes('Admin'))) {
      return true
    }
    return false
  }

  const [myRoutes, setMyRoutes] = useState(
    navigation.filter((route) => isRouteisAccessible(route?.to)),
  )

  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarBrand
        className="d-none d-md-flex"
        to="/"
        style={{ background: 'white', borderRight: '2px solid #3c4b64' }}
      >
        <img src={logo} height={50} alt="Logo" />

        {/* Use the <img> element to display the SVG image */}
      </CSidebarBrand>
      <CSidebarNav style={{ backgroundColor: '#4C4C4C' }}>
        <SimpleBar>
          <AppSidebarNav items={filteredNavs} />
        </SimpleBar>
      </CSidebarNav>
      {/* <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
      /> */}
    </CSidebar>
  )
}
AppSidebar.propTypes = {
  filteredNavs: PropTypes.array,
}
export default React.memo(AppSidebar)
